import {IUser,PagingType} from "@backend/types"
import {userActions} from "./service"

type UserState = {
    users?: PagingType<IUser>
}

export function userReducer(state: UserState = {}, action): UserState {

    switch (action.type) {
        case userActions.actionTypes.LIST: {
            const users: PagingType<IUser> = action.payload
            return {users}
        }

        default:
            return state
    }
}
